import React from 'react';
import { IconButton } from '@mui/material';
import { StudioFlowColors } from '../studioFlowTheme';

interface FlowBackButtonProps {
  onClick: () => void;
}

export const FlowBackButton: React.FC<FlowBackButtonProps> = ({ onClick }) => (
  <IconButton
    aria-label="Go back"
    onClick={onClick}
    disableRipple
    sx={{
      width: 44,
      height: 44,
      ml: -1,
      color: StudioFlowColors.title,
      borderRadius: '50%',
      '&:hover': {
        bgcolor: StudioFlowColors.selectionStroke,
      },
    }}
  >
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden>
      <path
        d="M15 18L9 12L15 6"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </IconButton>
);
